var _line, _line2, _line3, _line4, _line5, _line6, _line7, _path, _line8, _path2, _line9, _line10, _line11, _line12, _path3, _line13, _line14, _line15, _line16, _line17, _path4, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco703Template = function SvgFefco703Template(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "625.0mm",
    height: "400.0mm",
    viewBox: "0.0 0.0 625.0 400.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 31,
    y1: 293,
    y2: 396,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 104.6,
    y1: 396,
    y2: 396,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 104.6,
    x2: 108.6,
    y1: 396,
    y2: 400,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 108.6,
    x2: 147.4,
    y1: 400,
    y2: 400,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 147.4,
    x2: 151.4,
    y1: 400,
    y2: 396,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 151.4,
    x2: 195.9,
    y1: 396,
    y2: 396,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 234,
    x2: 280,
    y1: 348,
    y2: 348,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 280 348 L 325 293 L 331 299 L 331 348"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 505.59999999999997,
    y1: 348,
    y2: 348,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 505.6 348 L 516 299 L 525 293 L 539.1421 307.1421 C 534 313 534 313 534 333 L 534 345"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 534,
    x2: 557.6,
    y1: 345,
    y2: 345,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 557.6,
    x2: 560.6,
    y1: 345,
    y2: 348,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 560.6,
    x2: 580,
    y1: 348,
    y2: 348,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    x2: 625,
    y1: 348,
    y2: 293,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 219 296 L 225 293 L 239.1421 307.1421 C 234 313 234 313 234 333 L 234 348"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 625,
    x2: 525,
    y1: 293,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 451.3999999999999,
    x2: 525,
    y1: 293,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 396.59999999999997,
    x2: 325,
    y1: 293,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 325,
    x2: 225,
    y1: 293,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 225,
    y1: 293,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 398.6 295 l 50.8 0 a 2 2 0 0 0 0 -4 l -50.8 0 a 2 2 0 0 0 0 4"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 239.14213562373095,
    x2: 280,
    y1: 307.14213562373095,
    y2: 348,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 539.142135623731,
    x2: 580,
    y1: 307.14213562373095,
    y2: 348,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 195.9,
    x2: 219,
    y1: 396,
    y2: 296,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 25,
    y1: 293,
    y2: 291.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 22.7,
    y1: 291.5,
    y2: 287.9,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7,
    x2: 0,
    y1: 287.9,
    y2: 266.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 116,
    y2: 266.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 0,
    y1: 103.5,
    y2: 116,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 31,
    y1: 97.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 219,
    x2: 31,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 219,
    x2: 219,
    y1: 0,
    y2: 94.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 231,
    x2: 231,
    y1: 94.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    x2: 231,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    x2: 319,
    y1: 94.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 331,
    y1: 0,
    y2: 94.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 519,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 519,
    x2: 519,
    y1: 94.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 531,
    x2: 531,
    y1: 0,
    y2: 94.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 619.75,
    x2: 531,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 619.75,
    x2: 619.75,
    y1: 92.25,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 619.75 92.25 C 619.75 93.25 624 97.5 625 97.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 519 94.5 C 519 95.5 524 97.5 525 97.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 531 94.5 C 531 95.5 526 97.5 525 97.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 319 94.5 C 319 95.5 324 97.5 325 97.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 331 94.5 C 331 95.5 326 97.5 325 97.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 219 94.5 C 219 95.5 224 97.5 225 97.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 31 97.5 C 31 98.5 26 103.5 25 103.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 231 94.5 C 231 95.5 226 97.5 225 97.5"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 625,
    x2: 625,
    y1: 97.5,
    y2: 293,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 25,
    y1: 103.5,
    y2: 291.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 219,
    y1: 94,
    y2: 94,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 225,
    x2: 325,
    y1: 97.5,
    y2: 97.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 519,
    y1: 94.5,
    y2: 94.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 525,
    x2: 625,
    y1: 97.5,
    y2: 97.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 525,
    x2: 525,
    y1: 97.5,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 325,
    x2: 325,
    y1: 97.5,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 225,
    x2: 225,
    y1: 97.5,
    y2: 293,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco703Template, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-703-template.35658e97.svg";
export { ForwardRef as ReactComponent };